import { render } from "./amountTransferModal.vue?vue&type=template&id=1dc6f834&scoped=true"
import script from "./amountTransferModal.vue?vue&type=script&lang=js"
export * from "./amountTransferModal.vue?vue&type=script&lang=js"

import "./amountTransferModal.vue?vue&type=style&index=0&id=1dc6f834&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc6f834"]])

export default __exports__